export const SELECT_GROUP = 'SELECT_GROUP';
export const SHOW_LOADING_GROUP = 'SHOW_LOADING_GROUP';
export const FETCH_GROUP_PROFILES = 'FETCH_GROUP_PROFILES';
export const TOGGLE_GROUP_CHECKOUT_SELECT = 'TOGGLE_GROUP_CHECKOUT_SELECT';
export const TOGGLE_GROUP_PROFILE_SELECT = 'TOGGLE_GROUP_PROFILE_SELECT';
export const ACCOUNT_GROUP_PROFILE = 'ACCOUNT_GROUP_PROFILE';
export const CHECKOUT_GROUP = 'CHECKOUT_GROUP';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/group/state/types.js